module.exports = __webpack_public_path__ + "img/ppr-logo-reversed-logomark-200.d7187590.svg";